<!-- ===== Desktop Sidebar (expanded 248px / collapsed 72px) ===== -->
<aside class="sg-sidebar" [class.sg-sidebar--collapsed]="isCollapsed" *ngIf="!isBottomSidebar">
  <!-- Brand Header -->
  <div class="sg-sidebar__brand">
    <!-- Plegado no hay logo: el botón de mostrar ocupa su sitio, a la misma altura
         que el de ocultar. -->
    <a [routerLink]="appIcon?.route || '/'" class="sg-sidebar__brand-icon" *ngIf="!isCollapsed">
      <img
        *ngIf="appIcon?.image"
        [src]="appIcon!.image"
        [alt]="appIcon!.title || 'Synapseguard'"
        class="sg-sidebar__brand-img"
      >
      <i *ngIf="!appIcon?.image && appIcon?.icon" [class]="appIcon!.icon"></i>
    </a>
    <div class="sg-sidebar__brand-text" *ngIf="!isCollapsed">
      <span class="sg-sidebar__brand-name">{{ appIcon?.title || 'Synapseguard' }}</span>
      <!-- Cliente activo y, si el usuario es miembro de otros en este entorno, el selector
           para cambiar sin cerrar sesión. Con UNA sola URL para varios clientes, esta
           etiqueta es el único aviso de estar en el equivocado. Su menú se ancla a la
           cabecera (`.sg-sidebar__brand`, position: relative), no a la etiqueta. -->
      <sg-selector-organizacion variante="barra"></sg-selector-organizacion>
    </div>
    <!-- Buscar conversaciones (estilo Claude: icono en la cabecera, junto al
         collapse). Solo tiene sentido con el listado a la vista. -->
    <button
      type="button"
      class="sg-sidebar__collapse-btn sg-sidebar__search-btn"
      [class.sg-sidebar__search-btn--active]="showThreadSearch"
      *ngIf="!isCollapsed && agentLink.isActive"
      (click)="toggleThreadSearch()"
      [title]="'agent.searchConversations' | translate">
      <i class="pi pi-search"></i>
    </button>
    <!-- Mostrar/ocultar el panel: el icono de panel lateral de siempre, y el MISMO
         botón en los dos estados, en la misma fila. Antes el de desplegar era un
         «›» suelto al fondo del rail, junto al avatar. -->
    <button
      type="button"
      class="sg-sidebar__collapse-btn sg-sidebar__toggle-btn"
      (click)="toggleCollapse()"
      [attr.aria-expanded]="!isCollapsed"
      [title]="(isCollapsed ? 'nav.sidebar.expand' : 'nav.sidebar.collapse') | translate"
      [attr.aria-label]="(isCollapsed ? 'nav.sidebar.expand' : 'nav.sidebar.collapse') | translate">
      <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.75"/><path d="M9 3 V21" stroke="currentColor" stroke-width="1.75"/></svg>
    </button>
  </div>

  <!-- Navigation Sections -->
  <nav class="sg-sidebar__nav">
    <div class="sg-sidebar__section" *ngFor="let section of visibleSections">
      <div class="sg-sidebar__section-label" *ngIf="!isCollapsed">{{ section.label }}</div>
      <div class="sg-sidebar__section-divider" *ngIf="isCollapsed"></div>
      <a
        *ngFor="let item of section.items"
        [routerLink]="item.route"
        routerLinkActive="sg-sidebar__item--active"
        class="sg-sidebar__item"
        [title]="isCollapsed ? item.label : ''"
      >
        <span class="sg-sidebar__item-indicator"></span>
        <i [class]="item.icon" class="sg-sidebar__item-icon"></i>
        <span class="sg-sidebar__item-label" *ngIf="!isCollapsed">{{ item.label }}</span>
        <span
          *ngIf="item.count && item.count > 0 && !isCollapsed"
          class="sg-sidebar__item-badge"
          [class.sg-sidebar__item-badge--critical]="true"
        >{{ item.count > 999 ? '999+' : item.count }}</span>
        <span *ngIf="item.meta && !isCollapsed" class="sg-sidebar__item-meta">{{ item.meta }}</span>
      </a>
    </div>

    <!-- Agent Pinned. Con la ruta activa, sus conversaciones se despliegan
         justo debajo; al cambiar de pestaña desaparecen. La fila lleva su
         acción primaria a la derecha: [+] crea una conversación (sustituye a
         la antigua fila "+ Nueva conversación"). El badge "live" decorativo
         se retiró: en su hueco aparece el contador de turnos corriendo en
         otras conversaciones — información de verdad, y solo cuando la hay.
         Enlace y botón son HERMANOS: nada de controles anidados. -->
    <div class="sg-sidebar__agent-section">
      <div class="sg-sidebar__agent" [class.sg-sidebar__agent--active]="agentLink.isActive">
        <a
          routerLink="/agent"
          routerLinkActive
          #agentLink="routerLinkActive"
          class="sg-sidebar__agent-link"
          [title]="isCollapsed ? ('nav.agent' | translate) : ''"
        >
          <i class="pi pi-bolt sg-sidebar__agent-icon"></i>
          <span class="sg-sidebar__agent-label" *ngIf="!isCollapsed">{{ 'nav.agent' | translate }}</span>
        </a>

        <span class="sg-sidebar__agent-running"
          *ngIf="!isCollapsed && runningCount() > 0"
          [title]="'agent.runningElsewhere' | translate: { count: runningCount() }">
          <span class="sg-sidebar__agent-running-dot"></span>
          {{ runningCount() }}
        </span>

        <button type="button" class="sg-sidebar__agent-new"
          *ngIf="!isCollapsed && agentLink.isActive"
          (click)="startNewConversation()"
          [title]="'agent.newConversation' | translate"
          [attr.aria-label]="'agent.newConversation' | translate">
          <i class="pi pi-plus"></i>
        </button>

        <!-- Colapsado: punto SOLO cuando hay trabajo en marcha -->
        <span class="sg-sidebar__agent-dot--solo" *ngIf="isCollapsed && runningCount() > 0"></span>
      </div>

      <sg-agent-thread-list
        *ngIf="agentLink.isActive && !isCollapsed"
        variant="sidebar"></sg-agent-thread-list>
    </div>
  </nav>

  <!-- Paleta de búsqueda de conversaciones (estilo Cmd+K de Claude): overlay
       en grande sobre toda la app, abierto por la lupa de la cabecera. -->
  <sg-thread-search-overlay
    *ngIf="showThreadSearch"
    (closed)="showThreadSearch = false"></sg-thread-search-overlay>

  <!-- User Footer -->
  <div class="sg-sidebar__user" *ngIf="user">
    <button type="button" class="sg-sidebar__user-avatar-btn" (click)="goToSettings()">
      <div class="sg-sidebar__user-avatar" [class.sg-sidebar__user-avatar--initials]="!user.avatar"
           [style.background]="user.avatar ? null : user.avatarBackground">
        <!-- Si la foto no carga, se cae a las iniciales (con el color de Ajustes). -->
        <img *ngIf="user.avatar" [src]="user.avatar" [alt]="user.name" (error)="user.avatar = undefined">
        <span *ngIf="!user.avatar">{{ user.initials || getInitials(user.name) }}</span>
      </div>
    </button>
    <div class="sg-sidebar__user-info" *ngIf="!isCollapsed">
      <span class="sg-sidebar__user-name">{{ user.nickname || user.name }}</span>
      <!-- Sin rol se DICE, no se esconde ni se rellena: esa persona entra y no ve
           ninguna pestaña, y antes aquí se leía «usuario» como si tuviera uno. -->
      <span class="sg-sidebar__user-role"
            [class.sg-sidebar__user-role--sin-rol]="!user.role">{{ user.role || SIN_ROL }}</span>
    </div>
    <button type="button" class="sg-sidebar__user-settings" (click)="goToSettings()" *ngIf="!isCollapsed" title="Settings">
      <i class="pi pi-cog"></i>
    </button>
  </div>
</aside>

<!-- ===== Mobile/Tablet Bottom Bar ===== -->
<div class="sg-bottombar" *ngIf="isBottomSidebar">
  <a
    *ngIf="appIcon"
    [routerLink]="appIcon.route || '/agent'"
    class="sg-bottombar__logo"
    [attr.aria-label]="appIcon.title || 'Synapseguard'"
  >
    <img
      *ngIf="appIcon.image"
      [src]="appIcon.image"
      [alt]="appIcon.title || 'Synapseguard'"
      class="sg-bottombar__logo-img"
    >
    <i *ngIf="!appIcon.image && appIcon.icon" [class]="appIcon.icon"></i>
  </a>
  <div class="sg-bottombar__nav">
    <ng-container *ngFor="let item of otherNavItems">
      <a
        *ngIf="item.route"
        [routerLink]="item.route"
        routerLinkActive="sg-bottombar__item--active"
        class="sg-bottombar__item"
      >
        <p-overlaybadge *ngIf="item.count && item.count > 0" [value]="item.count > 99 ? '99+' : item.count.toString()">
          <i [class]="item.icon"></i>
        </p-overlaybadge>
        <i *ngIf="!item.count || item.count === 0" [class]="item.icon"></i>
      </a>
    </ng-container>
  </div>
  <div class="sg-bottombar__user" *ngIf="user">
    <button type="button" class="sg-bottombar__avatar-btn" (click)="goToSettings()">
      <div class="sg-bottombar__avatar" [class.sg-bottombar__avatar--initials]="!user.avatar"
           [style.background]="user.avatar ? null : user.avatarBackground">
        <!-- Si la foto no carga, se cae a las iniciales (con el color de Ajustes). -->
        <img *ngIf="user.avatar" [src]="user.avatar" [alt]="user.name" (error)="user.avatar = undefined">
        <span *ngIf="!user.avatar">{{ user.initials || getInitials(user.name) }}</span>
      </div>
    </button>
  </div>
</div>
